<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-14 19:03:34
 * @FilePath: 
 * @Description: 会员卡交易记录
-->
<template>
  <div>
    <van-tabs v-model="activeTab" sticky :color="$store.state.tc">
      <van-tab v-for="index in tabList" :title="index" :key="index">
        <div class="purchase_list_con">
          <template v-if="activeTab == 0">
            <div class="purchase_list_title">
              <p class="">累计消费 ￥{{ giftMoney }}</p>
              <p class="">累计充值 ￥{{ baseMoney }}</p>
            </div>
            <div class="p-20" style="background: #f1f7ff">
              <van-row type="flex" justify="space-between" gutter="10">
                <van-col span="9">时间</van-col>
                <van-col span="9">记录原因</van-col>
                <van-col span="6">金额（元）</van-col>
              </van-row>
            </div>
            <van-list
              v-model="loadingList"
              :finished="finished"
              finished-text="没有更多了"
              @load="handleGetMoreData"
            >
              <div
                class="p-tb-20 p-lr-20 font-26 bg-white"
                v-for="(item, index) in balanceList"
                :key="index"
              >
                <van-row type="flex" justify="space-between" gutter="10">
                  <van-col span="9">{{ item.FeeInDate }}</van-col>
                  <van-col span="9">{{ item.FeeType }}</van-col>
                  <van-col span="6">{{ item.Money }}</van-col>
                </van-row>
              </div>
            </van-list>
          </template>
          <template v-if="activeTab == 1">
            <div class="p-20" style="background: #f1f7ff">
              <van-row type="flex" justify="space-between" gutter="10">
                <van-col span="9">时间</van-col>
                <van-col span="9">记录原因</van-col>
                <van-col span="6">次数</van-col>
              </van-row>
            </div>
            <van-list
              v-model="loadingSecondaryList"
              :finished="finishedSecondary"
              finished-text="没有更多了"
              @load="handleGetMoreSecondaryListData"
            >
              <div
                class="p-tb-20 p-lr-20 font-26 bg-white"
                v-for="(item, index) in secondaryList"
                :key="index"
              >
                <van-row type="flex" justify="space-between" gutter="10">
                  <van-col span="9">{{ item.OperateDate }}</van-col>
                  <van-col span="9">{{ item.Type }}</van-col>
                  <van-col span="6">{{ item.Times }}</van-col>
                </van-row>
              </div>
            </van-list>
          </template>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "PurchaseHistory",
  props: {},
  data() {
    return {
      activeTab: 0,
      tabList: ["余额记录", "次卡记录"],
      giftMoney: 0,
      baseMoney: 0,
      loadingList: false,
      finished: false,
      loadingSecondaryList: false,
      finishedSecondary: false,
      balanceList: [],
      secondaryList: [
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
        { OperateDate: "2022-07-11 16:22:23", Type: "充值", Times: 30 },
      ],
    };
  },
  components: {},
  created() {
    this.handleGetBalanceList();
  },
  mounted() {},
  methods: {
    handleGetBalanceList() {
      this.balanceList = [
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
        { FeeInDate: "2022-07-11 16:22:23", FeeType: "充值", Money: 30 },
      ];
    },
    handleGetMoreData() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.balanceList.push({
            FeeInDate: "2022-07-11 16:22:23",
            FeeType: "充值" + i,
            Money: 30 + i,
          });
        }

        // 加载状态结束
        this.loadingList = false;

        // 数据全部加载完成
        if (this.balanceList.length >= 40) {
          this.finished = true;
        }
      }, 1000);
    },
    handleGetMoreSecondaryListData() {
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.secondaryList.push({
            OperateDate: "2022-07-15 16:22:23",
            Type: "充值" + i,
            Times: 10 + i,
          });
        }

        // 加载状态结束
        this.loadingSecondaryList = false;

        // 数据全部加载完成
        if (this.secondaryList.length >= 30) {
          this.finishedSecondary = true;
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.purchase_list_con {
  .purchase_list_title {
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
}
</style>
